import {
  useEffect,
  useState,
} from 'react';

import { useSnackbar } from 'notistack';
import Dynamicore, { SERVICES } from 'services/dynamicore';
import { dynamicSort } from 'utils/arrays';

import { updateValuesFromMapeo } from '../constants';

// Maneja el CRUD de firmantes  carga de la lista/tabla, alta y baja.

export default function useSignerCrud({
  t,
  selectors,
  setCurrentView,
  setModal2,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const [signers, setSigners] = useState([]);
  const [table, setTable] = useState();
  const [company] = useState(() => JSON.parse(localStorage.getItem('company')));
  const [isLoading, setIsLoading] = useState(false);

  //Carga de firmantes
  const loadSigners = async function () {
    const { values = [], total = 0 } = await Dynamicore(
      SERVICES.DOCUMENTS_TEMPLATES_SIGNERS,
    ).get();

    setSigners(values.sort(dynamicSort('name')));

    let updateValues = values;

    if (values.length > 0) {
      updateValues = updateValuesFromMapeo(updateValues);
    }

    setTable({
      rows: updateValues.sort(dynamicSort('name')),
      total,
    });
  };

  useEffect(() => {
    loadSigners();
  }, []);

  const handleSubmitData = async function (data) {
    setIsLoading(true);
    let message,
      variant = 'success';

    try {
      if (!data?.description) {
        data.description = ' ';
      }

      data.company = company.id;
      data.mapeo = {};

      if (selectors.selectorType === 1) {
        data.cantidad = 1;
        data.type = 'default';
        data.type_id = -1;
      } else if (selectors.selectorType === 2) {
        data.mapeo = {
          name: data?.name,
          email: data?.email,
          telefono: data?.telefono,
          displayNameName: selectors.valuesClient.find(
            (item) => item.id === data?.name,
          )?.name,
          displayNameEmail: selectors.valuesClient.find(
            (item) => item.id === data?.email,
          )?.name,
          displayNameTelefono: selectors.valuesClient.find(
            (item) => item.id === data?.telefono,
          )?.name,
        };
        data.name = ' ';
        data.email = ' ';
        data.telefono = ' ';
        data.cantidad = 1;
        data.type = 'client';
        data.type_id = selectors.selectorClient;
      } else if (selectors.selectorType === 3) {
        data.mapeo = {
          name: data?.name,
          email: data?.email,
          telefono: data?.telefono,
          displayNameName: selectors.valuesClient.find(
            (item) => item.id === data?.name,
          )?.name,
          displayNameEmail: selectors.valuesClient.find(
            (item) => item.id === data?.email,
          )?.name,
          displayNameTelefono: selectors.valuesClient.find(
            (item) => item.id === data?.telefono,
          )?.name,
        };
        data.name = ' ';
        data.email = ' ';
        data.telefono = ' ';
        data.cantidad = 1;
        data.type = 'relations';
        data.type_id = selectors.selectorRelationShip;
      }

      await Dynamicore(SERVICES.DOCUMENTS_TEMPLATES_SIGNERS).post(data);

      selectors.resetSelectors();

      loadSigners();
      setCurrentView('list');
      message = t('forms.messages.signer_saved');
    } catch (e) {
      message = e.message || t('forms.messages.signer_saving_error');
      variant = 'error';
    } finally {
      enqueueSnackbar(message, {
        variant,
        autoHideDuration: 3000,
      });
      setIsLoading(false);
    }
  };

  const handleRemoveSigner = async function (id) {
    let message,
      variant = 'success';

    try {
      await Dynamicore(SERVICES.DOCUMENTS_TEMPLATES_SIGNERS).delete(
        {
          id,
        },
        true,
      );

      message = t('forms.messages.signer_deleted');

      loadSigners();
      setModal2();
    } catch (error) {
      message = t('forms.messages.signer_deleting_error');
      variant = 'error';
    } finally {
      enqueueSnackbar(message, {
        variant,
      });
    }
  };

  return {
    signers,
    table,
    company,
    isLoading,
    handleSubmitData,
    handleRemoveSigner,
  };
}
